import { render, staticRenderFns } from "./PopularListOnPlate.vue?vue&type=template&id=5e30619b&scoped=true"
import script from "./PopularListOnPlate.vue?vue&type=script&lang=js"
export * from "./PopularListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./PopularListOnPlate.vue?vue&type=style&index=0&id=5e30619b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30619b",
  null
  
)

export default component.exports